module.exports = __webpack_public_path__ + "static/media/splunk-trustar-dark-logo.58156c5f.png";